import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faTachometerAlt, faCog, faUser } from '@fortawesome/free-solid-svg-icons';

const navConfig = {
  baseBefore: [
    {
      type: 'link',
      label: 'Dashboard',
      icon: faTachometerAlt,
      path: '/Dashboard'
    }
  ],
  baseAfter: [       
    {
      type: 'dropdown',
      label: 'Explore',
      icon: faCog,
      id: 'exploreDropdown',
      children: [        
        {label: 'Pregnancy Details Form', path: '/PregnancyDetailsForm'},
        { label: 'Make An Appointment', path: '/AppointmentForm' },
        { label: 'Child Vaccination Form', path: '/ChildVaccinationForm' },
        { label: 'Labor Progress Form', path: '/LaborProgressForm' },
        { label: 'Medical Record Form', path: '/MedicalRecordForm' },
        {label: 'Postnatal Visit Form', path: '/PostnatalVisitForm'}
      ]
    },
    {
      type: 'dropdown',
      label: 'Account',
      icon: faUser,
      id: 'accountDropdown',
      children: [
        { label: 'Logout', onClick: 'logout' },
      ]
    },
  ],
  userSpecific: {
    Admin: [
      {
        type: 'dropdown',
        label: 'System Settings',
        icon: faCog,
        id: 'systemSettingsDropdown',
        children: []
      },
      {
        type: 'dropdown',
        label: 'Business Operations',
        icon: faCog,
        id: 'businessOperationsDropdown',
        children: [
          { label: 'Register Staff', path: '/StaffRegistration' },
          { label: 'Register Client/Patient', path: '/PatientRegistration' }
        ]
      }
    ],
    Employee: [],
    Cashier: [],
    Site_Manager: [],
    Customer: [],
    Tenant: []
  }
};

export default function Header() {
  const { user, logout } = useAuth();
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const userType = localStorage.getItem('userType') || 'default';
  const userLinks = navConfig.userSpecific[userType] || [];

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const handleItemClick = (item) => {
    if (item.onClick === 'logout') {
      logout();
    }
  };

  const renderNavItem = (item, index) => {
    if (item.type === 'link') {
      return (
        <li key={index} className="nav-item">
          <Link className={`nav-link ${item.className || ''}`} to={item.path}>
            {item.icon && (
              <span className={item.iconContainerClass || ''}>
                <FontAwesomeIcon icon={item.icon} />
              </span>
            )}
            {item.label}
          </Link>
        </li>
      );
    }
    
    if (item.type === 'dropdown') {
      return (
        <li key={index} className="nav-item dropdown">
          <div
            className="nav-link dropdown-toggle"
            id={item.id}
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {item.icon && <FontAwesomeIcon icon={item.icon} />} {item.label}
          </div>
          <div className="dropdown-menu" aria-labelledby={item.id}>
            {item.children.map((child, childIndex) => (
              !child.hidden && (
                child.path ? (
                  <Link
                    key={childIndex}
                    className="dropdown-item"
                    to={child.path}
                  >
                    {child.label}
                  </Link>
                ) : (
                  <button
                    key={childIndex}
                    className="dropdown-item"
                    onClick={() => handleItemClick(child)}
                  >
                    {child.label}
                  </button>
                )
              )
            ))}
          </div>
        </li>
      );
    }
    
    return null;
  };

  return (
    <>
      {user ? (
        // Logged-in navigation
        <div className="dashboard">
          <nav id="navbar" className="navbar navbar-expand-lg navbar-light bg-white fixed-top">
            <div className="navbar-brand"> </div>
            <button className="navbar-toggler" type="button" onClick={toggleMobileMenu}>
              <span className="navbar-toggler-icon">
                {showMobileMenu ? <FontAwesomeIcon icon={faTimes} /> : <FontAwesomeIcon icon={faBars} />}
              </span>
            </button>
            <div className={`collapse navbar-collapse ${showMobileMenu ? 'show' : ''}`}>
              <ul className="navbar-nav mr-auto">
                {navConfig.baseBefore.map(renderNavItem)}
                {userLinks.map(renderNavItem)}
                {navConfig.baseAfter.map(renderNavItem)}
              </ul>
            </div>
          </nav>
        </div>
      ) : (
        // Logged-out navigation
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary sticky-top">
        <div className="container">
          <Link className="navbar-brand" to="/">Nurture Nest Midwifery Limited</Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">
              <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/about">About Us</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/care-packages">Care Packages</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/services">Services</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/womens-health">Women's Health</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/schedule-consultation">Consultation</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/contact">Contact Us</Link></li>
            </ul>
      
            {/* Login link aligned far right */}
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/Login">
                  <i className="fas fa-sign-in-alt me-1"></i>Login
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      
      
      )}
    </>
  );
}